'use strict';
define(['app'], function (app) {
    function Controller($element, $timeout) {
        var ctrl = this;
        var pending;
        ctrl.filter = '';
        ctrl.limit = 50;
        ctrl.$onChanges = function () {
            $timeout.cancel(pending);
            pending = $timeout(function () {
                var active = $element[0].querySelector('.st-research-tabs__item.is-active');
                var strip = $element[0].querySelector('.st-research-tabs__strip');
                if (active && strip) {
                    var itemBox = active.getBoundingClientRect();
                    var stripBox = strip.getBoundingClientRect();
                    if (itemBox.left < stripBox.left) { strip.scrollLeft -= stripBox.left - itemBox.left; }
                    if (itemBox.right > stripBox.right) { strip.scrollLeft += itemBox.right - stripBox.right; }
                }
            }, 0, false);
        };
        ctrl.scroll = function (direction) {
            var strip = $element[0].querySelector('.st-research-tabs__strip');
            strip.scrollLeft += direction * strip.clientWidth * 0.75;
        };
        ctrl.matches = function (item) {
            return item.label.toLowerCase().indexOf(ctrl.filter.toLowerCase().trim()) !== -1;
        };
        ctrl.select = function (item, event) {
            if (ctrl.disabled) { return; }
            ctrl.onSelect({item: item});
            var menu = event.currentTarget.closest('details');
            if (menu) { menu.open = false; }
        };
        ctrl.close = function (item, event) { ctrl.onClose({item: item, event: event}); };
        ctrl.$onDestroy = function () { $timeout.cancel(pending); };
    }
    Controller.$inject = ['$element', '$timeout'];
    app.component('stResearchTabs', {
        bindings: {items: '<', activeId: '<', disabled: '<', onSelect: '&', onClose: '&'},
        controller: Controller,
        templateUrl: 'app/components/st-research-tabs/st-research-tabs.html'
    });
});
